(() => {
  const initialize = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    root.querySelectorAll('a[href^="#ODEventSignup-"]').forEach(link => {
      link.addEventListener('click', event => {
        const destination = document.getElementById(link.hash.slice(1));
        if (!destination) return;
        event.preventDefault();
        destination.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
        destination.focus({preventScroll:true});
      });
    });
    const escape = value => value.replace(/\\/g,'\\\\').replace(/\n/g,'\\n').replace(/,/g,'\\,').replace(/;/g,'\\;');
    const dateString = date => date.toISOString().replace(/[-:]/g,'').replace(/\.\d{3}/,'');
    root.querySelectorAll('[data-event-calendar]').forEach(button => {
      const start = new Date(button.dataset.start), end = new Date(button.dataset.end);
      if (!Number.isFinite(start.getTime()) || !Number.isFinite(end.getTime()) || end <= start) {button.hidden=true;return;}
      button.addEventListener('click', () => {
        const data=['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//ONE AND DUNN//Events//EN','BEGIN:VEVENT',`UID:${start.getTime()}-${location.host}`,`DTSTAMP:${dateString(new Date())}`,`DTSTART:${dateString(start)}`,`DTEND:${dateString(end)}`,`SUMMARY:${escape(button.dataset.title)}`,`LOCATION:${escape(button.dataset.location)}`,'END:VEVENT','END:VCALENDAR'].join('\r\n');
        const url=URL.createObjectURL(new Blob([data],{type:'text/calendar;charset=utf-8'}));
        const link=document.createElement('a');link.href=url;link.download='one-and-dunn-event.ics';link.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
      });
    });
  };
  document.querySelectorAll('[data-od-events]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-od-events]').forEach(initialize));
})();
